/* eslint-disable no-param-reassign */
/* global Swiper, attachEvent */
// **********************************************************
// Subscriptions slider
// **********************************************************

const subscriptionsNavLink = document.querySelectorAll('.subscriptions-slider__nav-link');
const subscriptionsActiveNavLink = document.querySelectorAll('.subscriptions-slider__nav-link.is-active');
const subscriptionsSliderElements = document.querySelectorAll('[data-slider="subscriptions-slider"]');
const contents = document.querySelectorAll('.content-switcher__content');
const stickyTitles = document.querySelectorAll('.content-switcher__sticky .subscriptions-slider__title');

const subscriptionsSliderOptions = {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

function removeSubLinkActiveClass(element, indicator, stickyIndicator) {
  subscriptionsActiveNavLink.forEach((elm) => {
    elm.classList.remove('is-active');
  });
  element.classList.add('is-active');
  indicator.style.transform = `translateX(${element.offsetLeft}px)`;
  if (stickyIndicator) {
    stickyIndicator.style.transform = `translateX(${element.offsetLeft}px)`;
  }
}

function addContentActiveClass(target) {
  contents.forEach((content) => {
    content.classList.remove('is-active');
  });
  stickyTitles.forEach((stickyTitle) => {
    stickyTitle.classList.remove('is-active');
  });

  const targetContent = document.querySelector(`[data-content="${target}"]`);

  if (targetContent) {
    targetContent.classList.add('is-active');
  }

  const targetTitle = document.querySelector(`[data-stickytitle="${target}"]`);

  if (targetTitle) {
    targetTitle.classList.add('is-active');
  }
}

const changeSubColor = () => {
  const parent = document.querySelector('.sc-subscriptions-slider--no-overlay');
  if (parent) {
    const activeSlide = parent.querySelector('.subscriptions-slider__init .swiper-slide.swiper-slide-active');
    const slideDark = activeSlide.classList.contains('subscriptions-slider__slide--dark-text');
    const menu = document.querySelector('.header-main');
    menu?.classList.toggle('header-main--dark', slideDark);
    parent.classList.toggle('sc-subscriptions-slider--dark', slideDark);
  }
}

subscriptionsSliderElements.forEach((el) => {
  const parentElem = el.closest('.sc-subscriptions-slider');
  const activeIndicator = parentElem.querySelector('.subscriptions-slider__nav-active-indicator');
  const stickyActiveIndicator = document.querySelector('.sticky-indicator');
  const arrowRight = parentElem.querySelector('.arrow-right');
  const arrowLeft = parentElem.querySelector('.arrow-left');

  subscriptionsSliderOptions.navigation.nextEl = arrowRight;
  subscriptionsSliderOptions.navigation.prevEl = arrowLeft;

  const subscriptionsSlider = new Swiper(el, subscriptionsSliderOptions);

  attachEvent('.subscriptions-slider__nav-link', 'click', (ev) => {
    const targetSlide = ev.target.getAttribute('data-slide');
    subscriptionsSlider.slideTo(targetSlide, 300);
    removeSubLinkActiveClass(ev.target, activeIndicator, stickyActiveIndicator);
    addContentActiveClass(targetSlide);
  });

  subscriptionsSlider.on('slideChange', () => {
    const activeSlideIndex = subscriptionsSlider.realIndex;
    // eslint-disable-next-line max-len
    removeSubLinkActiveClass(subscriptionsNavLink[activeSlideIndex], activeIndicator, stickyActiveIndicator);
    addContentActiveClass(activeSlideIndex);
  });

  subscriptionsActiveNavLink.forEach((elm) => {
    const targetSlide = elm.getAttribute('data-slide');
    subscriptionsSlider.slideTo(targetSlide, 300);
    removeSubLinkActiveClass(elm, activeIndicator, stickyActiveIndicator);
    addContentActiveClass(targetSlide);
  });

  changeSubColor();
  subscriptionsSlider.on('slideChangeTransitionStart', () => changeSubColor());
});
